import React from 'react'
import _ from 'lodash'

import { TextField } from 'react-admin'

const ApiSummaryField = ({ record, filter }) => {
  const feeds = filter ? _.filter(record.feeds, filter) : record.feeds
  const unique_apis = [...new Set(feeds.map((f) => {
    return record.apis.filter(a => a.kind === f.api_kind)[0]
  }))]
  return (
    <div>
      { unique_apis.length > 0 ? unique_apis.map((item, i) => (
        <TextField key={i} record={item} source='kind' />))
        : (<div> — </div>)
      }
    </div>
  )
}

ApiSummaryField.defaultProps = { addLabel: true, label: 'APIs' }

export { ApiSummaryField }
